import React, { useMemo } from "react";
import { useRequestProcessor } from "../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail } from "../../AtomStore/store";
import { fetchOutdoorActivity } from "../../QueryFunctions/queryfunction";
import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";
import OutdoorActivityItem from "./Item";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";

const Activity = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [activeChild] = useAtom(activeChildDetail);

  useMemo(() => {
    console.log(
      `[Outdoor Activity] Fetching Outdoor Activity details for user: ${activeChild?.id}`
    );
  }, [activeChild]);
  const {
    data: outdoorActivity,
    isLoading,
    refetch,
  } = useQueryWrapper(
    ["outdoorActivity", "out" + activeChild?.id],
    () => {
      console.log("[Outdoor Activity] Calling API: /centerevents/my_events", {
        child_id: activeChild?.id,
      });
      return fetchOutdoorActivity();
    },
    {
      onSuccess: (data) => {
        console.log("[Outdoor Activity] Outdoor activity response:", data);
      },
    }
  );
  return (
    <div className="py-2 flex justify-center">
      {isLoading ? <SpinnerLoading /> : ""}
      {Array.isArray(outdoorActivity) && outdoorActivity.length > 0 && (
        <div className="grid grid-cols-12 gap-3">
          {outdoorActivity.map((item, index) => (
            <OutdoorActivityItem
              index={index}
              key={index}
              item={item}
              refetch={refetch}
            />
          ))}
        </div>
      )}
      {(!Array.isArray(outdoorActivity) ||
        outdoorActivity.length === 0 ||
        outdoorActivity === undefined) && (
        <div className="flex justify-center items-center my-6">
          <ListEmptyComponent
            heading={isLoading ? "Loading..." : "No Data Found"}
          />
        </div>
      )}
    </div>
  );
};

export default Activity;
